import PropTypes from 'prop-types';
import classnames from 'classnames';

import Gallery from 'dibs-icons/exports/legacy/Gallery';
import ArtworkFrame from 'dibs-icons/exports/legacy/ArtworkFrame';
import PlayButtonInverse from 'dibs-icons/exports/legacy/PlayButtonInverse';
import { Link } from 'dibs-elements/exports/Link';
import { VideoTile } from 'dibs-elements/exports/VideoTile';
import styles from './PdpSharedHeroCarouselThumb.scss';

export const PdpSharedHeroCarouselThumb = props => {
    const {
        index,
        isCurrentItem,
        isClient,
        isRoomView,
        thumbs,
        totalItems,
        size,
        onIndexChange,
        isRequestMoreImagesEnabled,
        isVideo,
    } = props;
    const { srcSet, src, alt } = thumbs[index] || {};
    const position = index + 1;
    const isCarouselLastItem = position === totalItems;
    const isRequestMoreImages = isCarouselLastItem && isRequestMoreImagesEnabled;

    let icon;
    let overlay;

    let img = isClient && <img className={styles.thumb} src={src} alt={alt} srcSet={srcSet} />;

    if (isRequestMoreImages) {
        icon = <Gallery className={styles.icon} />;
    }

    if (isRoomView) {
        overlay = (
            <span className={styles.frameOverlay}>
                <ArtworkFrame className={styles.icon} />
            </span>
        );
    }

    if (isVideo) {
        img = (
            <div className={styles.thumbVideo}>
                <VideoTile animate sourceUrl={src} />
            </div>
        );
        overlay = (
            <span className={styles.playIconOverlay}>
                <PlayButtonInverse className={styles.playIcon} />
            </span>
        );
    }

    const wrapperClasses = classnames(styles.wrapper, {
        [styles.isCurrent]: isCurrentItem && isClient,
        [styles.iconWrapper]: icon,
        [styles.placeholder]: !isClient,
        [styles.small]: size === 'small',
        [styles.medium]: size === 'medium',
    });

    const dataTn = `pdp-hero-carousel-image-thumb-${index}${isCurrentItem ? '-current' : ''}`;
    return (
        <Link className={wrapperClasses} onClick={() => onIndexChange({ index })} dataTn={dataTn}>
            {icon || img}
            {overlay}
        </Link>
    );
};

PdpSharedHeroCarouselThumb.propTypes = {
    index: PropTypes.number.isRequired,
    isCurrentItem: PropTypes.bool,
    isVideo: PropTypes.bool,
    isClient: PropTypes.bool,
    isRoomView: PropTypes.bool,
    thumbs: PropTypes.array.isRequired,
    size: PropTypes.string,
    totalItems: PropTypes.number.isRequired,
    onIndexChange: PropTypes.func,
    isRequestMoreImagesEnabled: PropTypes.bool,
};
